import { render, staticRenderFns } from "./AddMessage.vue?vue&type=template&id=f474eb88&scoped=true"
import script from "./AddMessage.vue?vue&type=script&lang=js"
export * from "./AddMessage.vue?vue&type=script&lang=js"
import style1 from "./AddMessage.vue?vue&type=style&index=1&id=f474eb88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f474eb88",
  null
  
)

export default component.exports